<template lang="pug" functional>
  .clients-item-skeleton
    .clients-item-skeleton__item(
      v-for="i in props.count"
      :key="i")
      v-card.clients-item-skeleton__wrapper
        .clients-item-skeleton__loader
        .clients-item-skeleton__loader

</template>

<script>
export default {
  name: 'ClientsItemSkeleton',

  props: {
    count: {
      type: Number,
      default: 7
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .clients-item-skeleton {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -1rem;
    
    &__item {
      width: 25%;
      padding: 0 1rem;
      margin-bottom: 2rem;

      @include tablet {
        width: 33.3%;
      }

      @include mobile {
        width: 100%;

        &:not(:last-child) {
          margin-bottom: 1.5rem;
        }
      }
    }

    &__wrapper {
      padding: 1.5rem 2.5rem;
    }

    &__loader {
      height: 2.2rem;
      width: 65%;
      border-radius: .8rem;

      &:last-child {
        margin-top: 1.2rem;
        height: 1.6rem;
        width: 50%;
      }

      @include skeleton;
    }
  }
</style>
